import TemplateMaker from '../templates';
import { printStudentsListColumns, printAttendanceListColumns, studentListWithMarksColumns } from '../../settings/tableColumns';
import { dynamicTabsActionTypes } from '.';
import { exhaustiveCheck } from '../../helpers/exhaustiveCheck';

export const initTabs = (path: string, history: any) => ({
  type: dynamicTabsActionTypes.TABS_INIT,
  payload: { path, history },
} as const);
export const openNewTab = (data: DynamicTabAttributes, history: any, noHistoryPush = false, tabsAmountOnInit?: number, search?: string) => {
  switch (data.tabType) {
    case 'strona-przedmiotu':
      return {
        type: dynamicTabsActionTypes.TAB_OPEN_NEW,
        noHistoryPush,
        tabsAmountOnInit,
        payload: {
          ...data,
          tabType: 'strona-przedmiotu',
          noAccess: false,
          initTable: !noHistoryPush,
          wasInitialized: !noHistoryPush,
          history,
          leftPanel: {
            data: {},
            loading: !noHistoryPush,
            error: false,
          },
          studentListWithMarks: {
            columns: studentListWithMarksColumns,
          },
          table: {
            ...TemplateMaker.table(),
            initTable: !noHistoryPush,
            expanded: null,
            search: search,
            columnsToPrint: printStudentsListColumns,
            columnsToAttendanceList: printAttendanceListColumns,
          },
        },
      };
    case 'strona-studenta':
      return {
        type: dynamicTabsActionTypes.TAB_OPEN_NEW,
        noHistoryPush,
        tabsAmountOnInit,
        payload: {
          ...data,
          tabType: 'strona-studenta',
          noAccess: false,
          initTable: !noHistoryPush,
          wasInitialized: !noHistoryPush,
          history,
          leftPanel: {
            data: {},
            loading: !noHistoryPush,
            error: false,
          },
          table: {
            ...TemplateMaker.table(),
            initTable: !noHistoryPush,
          },
        },
      };
    case 'karta-przedmiotu':
      return {
        type: dynamicTabsActionTypes.TAB_OPEN_NEW,
        noHistoryPush,
        tabsAmountOnInit,
        payload: {
          ...data,
          tabType: 'karta-przedmiotu',
          noAccess: false,
          initTable: !noHistoryPush,
          wasInitialized: !noHistoryPush,
          history,
          leftPanel: {
            data: {},
            loading: !noHistoryPush,
            error: false,
          },
          form: {
            loading: false,
            readOnly: true,
            error: false,
            templateVersion: undefined,
            formTemplates: [],
            formValues: [],
            originFormValues: [],
          },
        },
      };

    default:
      return exhaustiveCheck(data.tabType, 'tab');
  }
};
export const closeTab = (index: number, history: any, tabType?: string, activeTabId?: number) => ({
  type: dynamicTabsActionTypes.TAB_CLOSE,
  payload: { index, history, tabType, activeTabId },
} as const);
export const closeAllTabs = () => ({
  type: dynamicTabsActionTypes.TABS_CLOSE_ALL,
} as const);
export const setActiveTab = (activateKey: DynamicTabsState['activeTab']) => ({
  type: dynamicTabsActionTypes.TAB_SET_ACTIVE,
  payload: { activateKey },
} as const);

type tabId = DynamicTabComponent['id'];

export const setLeftPanelLoading = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.SET_LEFT_PANEL_LOADING,
  payload: { tabId },
} as const);
export const getLeftPanelDataSuccess = (tabId: tabId, data: SingleObjectDataStructure, titleTranslationKey: string) => ({
  type: dynamicTabsActionTypes.GET_LEFT_PANEL_DATA_SUCCESS,
  payload: { tabId, data, titleTranslationKey },
} as const);
export const getLeftPanelDataFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.GET_LEFT_PANEL_DATA_FAIL,
  payload: { tabId },
} as const);
// fixme: uzupelnij typ payload
export const getDataSuccess = (tabId: tabId, data: GetDataSuccessPayload) => ({
  type: dynamicTabsActionTypes.GET_DATA_SUCCESS,
  payload: { tabId, data },
} as const);
export const getDataFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.GET_DATA_FAIL,
  payload: { tabId },
} as const);
export const setDataAfterSort = (tabId: tabId, data: SingleObjectDataStructure[]) => ({
  type: dynamicTabsActionTypes.SET_DATA_AFTER_SORT,
  payload: { tabId, data },
} as const);
export const setDataAttendanceListAfterSort = (tabId: tabId, data: SingleObjectDataStructure[]) => ({
  type: dynamicTabsActionTypes.SET_DATA_ATTENDANCE_LIST_AFTER_SORT,
  payload: { tabId, data },
} as const);
export const getDataNextPage = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.GET_DATA_NEXT_PAGE_START,
  payload: { tabId },
} as const);
export const getDataNextPageSuccess = (tabId: tabId, data: any) => ({
  type: dynamicTabsActionTypes.GET_DATA_NEXT_PAGE_SUCCESS,
  payload: { tabId, data },
} as const);
export const getDataNextPageFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.GET_DATA_NEXT_PAGE_FAIL,
  payload: { tabId },
} as const);
export const setLoading = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.SET_LOADING,
  payload: { tabId },
} as const);
export const setSearch = (tabId: tabId, search: ViewDataSet['search']) => ({
  type: dynamicTabsActionTypes.SET_SEARCH,
  payload: { tabId, search },
} as const);
export const init = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.INIT,
  payload: { tabId },
} as const);
export const initTableFinish = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.INIT_TABLE_FINISH,
  payload: { tabId },
} as const);
export const initFinish = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.INIT_FINISH,
  payload: { tabId },
} as const);
export const setSelected = (tabId: tabId, selected: ViewDataSet['selected']) => ({
  type: dynamicTabsActionTypes.SET_SELECTED,
  payload: { tabId, selected },
} as const);
export const setOrder = (tabId: tabId, settings: ViewDataSet['sorting']) => ({
  type: dynamicTabsActionTypes.SET_ORDER,
  payload: { tabId, settings },
} as const);
export const setExpanded = (tabId: tabId, expanded: ViewDataSet['expanded']) => ({
  type: dynamicTabsActionTypes.SET_EXPANDED,
  payload: { tabId, expanded },
} as const);
export const setPage = (tabId: tabId, page: ViewDataSet['page']) => ({
  type: dynamicTabsActionTypes.SET_PAGE,
  payload: { tabId, page },
} as const);
export const setDetailsLoading = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.SET_DETAILS_LOADING,
  payload: { tabId },
} as const);
export const getRecordDetails = (tabId: tabId, recordId: string | number, refresh: boolean) => ({
  type: dynamicTabsActionTypes.RECORD_GET_DETAILS_START,
  payload: { tabId, recordId, refresh },
} as const);
export const getRecordDetailsSuccess = (tabId: tabId, data: SingleObjectDataStructure, marksData: SingleObjectDataStructure, recordId: string | number) => ({
  type: dynamicTabsActionTypes.RECORD_GET_DETAILS_SUCCESS,
  payload: { tabId, data, marksData, recordId },
} as const);
export const getRecordDetailsFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.RECORD_GET_DETAILS_FAIL,
  payload: { tabId },
} as const);
export const getColumnsConfigSuccess = (tabId: tabId, mainColumns: SingleColumn[], marksColumns?: SingleColumn[]) => ({
  type: dynamicTabsActionTypes.COLUMNS_GET_CONFIG_SUCCESS,
  payload: { tabId, mainColumns, marksColumns },
} as const);
export const getColumnsConfigFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.COLUMNS_GET_CONFIG_FAIL,
  payload: { tabId },
} as const);
export const changeColumnsSorting = (tabId: tabId, sortingInfo: Helpers.SortingInfo) => ({
  type: dynamicTabsActionTypes.COLUMNS_CHANGE_SORTING,
  payload: { tabId, sortingInfo },
} as const);
export const saveColumnsUserSetup = (tabId: tabId, tabType: DynamicTabType) => ({
  type: dynamicTabsActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { tabId, tabType },
} as const);
export const saveColumnsUserSetupSuccess = (tabId: tabId, data: SingleColumn[]) => ({
  type: dynamicTabsActionTypes.COLUMNS_SAVE_USER_SETUP_SUCCESS,
  payload: { tabId, data },
} as const);
export const selectFilterValues = (tabId: tabId, filters: SelectFilterValuesPayload) => ({
  type: dynamicTabsActionTypes.FILTERS_SELECT_VALUES,
  payload: { tabId, filters },
} as const);
export const closeFilterCategory = (tabId: tabId, filter: string) => ({
  type: dynamicTabsActionTypes.FILTERS_CLOSE_CATEGORY,
  payload: { tabId, filter },
} as const);
export const openFilterCategory = (tabId: tabId, filtersGroups: FilterSettings) => ({
  type: dynamicTabsActionTypes.FILTERS_OPEN_CATEGORY,
  payload: { tabId, filtersGroups },
} as const);
// fixme: okresl interfejs dla payloady data
export const refreshFilterValueSuccess = (tabId: tabId, data: { [key: string]: any[] }) => ({
  type: dynamicTabsActionTypes.FILTERS_REFRESH_VALUES_SUCCESS,
  payload: { tabId, data },
} as const);
export const refreshFilterValueFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.FILTERS_REFRESH_VALUES_FAIL,
  payload: { tabId },
} as const);

// fixme: okresl interfejs dla filtrow
export const getFiltersConfigSuccess = (tabId: tabId, data: any[]) => ({
  type: dynamicTabsActionTypes.FILTERS_GET_CONFIG_SUCCESS,
  payload: { tabId, data },
} as const);
export const getFiltersConfigFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.FILTERS_GET_CONFIG_FAIL,
  payload: { tabId },
} as const);
export const refreshData = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.REFRESH_DATA_START,
  payload: { tabId },
} as const);
export const refreshDataSuccess = (tabId: tabId, data: any[]) => ({
  type: dynamicTabsActionTypes.REFRESH_DATA_SUCCESS,
  payload: { tabId, data },
} as const);
export const refreshDataFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.REFRESH_DATA_FAIL,
  payload: { tabId },
} as const);
export const refreshSelectedData = (tabId: tabId, recordsToRefresh: ViewDataSet['selected']) => ({
  type: dynamicTabsActionTypes.REFRESH_SELECTED_DATA_START,
  payload: { tabId, recordsToRefresh },
} as const);
export const refreshSelectedDataSuccess = (tabId: tabId, data: any[], recordsToRefresh: ViewDataSet['selected']) => ({
  type: dynamicTabsActionTypes.REFRESH_SELECTED_DATA_SUCCESS,
  payload: { tabId, data, recordsToRefresh },
} as const);
export const refreshSelectedDataFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.REFRESH_SELECTED_DATA_FAIL,
  payload: { tabId },
} as const);
export const syncDataWithCache = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_START,
  payload: { tabId },
} as const);
export const syncDataWithCacheSuccess = (tabId: tabId, data: Pick<WithCache, 'controlSum' | 'duration' | 'isUpToDate'>) => ({
  type: dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_SUCCESS,
  payload: { tabId, data },
} as const);
export const syncDataWithCacheFail = (tabId: tabId) => ({
  type: dynamicTabsActionTypes.SYNC_DATA_WITH_CACHE_FAIL,
  payload: { tabId },
} as const);
